import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, OnChanges, Renderer2 } from '@angular/core';

import * as echarts from 'echarts';
import EChartOption = echarts.EChartOption;
import { Data } from '../../../models';
import { CoreService, HttpService } from '../../../services';
declare var $: any;
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'quest-pie',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.css']
})
export class PieComponent implements OnInit, OnChanges {
  @ViewChild('graph', { static: false }) graph: ElementRef;
  myChart: any;
  /* @ViewChild('chart') cavnasChart: ElementRef;
   public ChartLegend = true;
   public Type: string;
   public ChartOptions: any;
   private Chart: any;
   private ChartLabel: any;*/

  @Input() ChartLabels: string[];
  @Input() ChartData: Data[];
  @Input() ChartColor = 0;
  @Input() ChartType: string;
  @Input() Element: string;

  @Input() IdChart: string = '#graphDiv';
  data: any[];
  myColors: any[];


  constructor(protected IndParam: CoreService,
    protected http: HttpService,
    protected renderer: Renderer2) { }


  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (this.ChartData && this.ChartData.length > 0) {
      this.myChart.resize();
    }
  }


  ngOnInit() {
    /* switch (this.ChartType) {
       case 'CHECKLISTE':
       case 'RADIOLISTE':
       case 'CHECKLISTENOTEQUESTION':
       case 'RADIOLISTEPNOTEQUESTION':
         this.bar();
         break;
       case 'TEXTBOX':
         break;
       case 'SATISFACTION':
         this.line();
         break;
       default:
         this.default();
         break; 
     }
  
  
     this.data = [{ data: this.ChartData.data, label: this.ChartData.label }, ];*/
  }


  ngOnChanges(): void {
    if (this.ChartData.length > 0) {
      const style: CSSStyleDeclaration = getComputedStyle(document.body);
      const Cmain: string = style.getPropertyValue('--c-main');
      const Csecondary: string = style.getPropertyValue('--c-secondary');
      const clightmain: string = style.getPropertyValue('--c-light-main');    

      //Build Data
      let index: number = 0;
      let dataChart: Array<any> = new Array<any>();
      this.ChartData.forEach((d: any) => {
        var value = d.Value;
        var name = `${d.Label} (${d.Value})`;
        var label = index == 0 ? { color: '#85c13b', fontSize: '15', fontWeight: 'bold' } : { color: 'rgba(0, 0, 0, 0.5)' };
        var itemStyle = index == 0 ? { color: Cmain, shadowBlur: 10, shadowColor: 'rgba(0, 0, 0, 0.3)' } : { color: '#c23531' };
        dataChart.push({ value, name, label, itemStyle })
        index++;
      })

      dataChart.sort((a: any, b: any) => {
        let result = 0;
        if (a.value > b.value) {
          result = 1;
        } else if (a.value < b.value) {
          result = -1
        }
        return result;
      })

      setTimeout(() => {
        this.myChart = echarts.init(this.graph.nativeElement);
        this.myChart.setOption({

          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)'
          },

          series: [{
            data: dataChart,
            type: 'pie',
            radius: '80%',
            center: ['50%', '50%'],
            roseType: 'radius',
            labelLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.5)'
              },
              smooth: 0.2,
              length: 10,
              length2: 20
            },


            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx: any) {
              return Math.random() * 200;
            }

          }]
        });
      }, 1);



      const interval = setInterval(() => {
        const width = $(`#${this.IdChart}`).width();
        const height = $(`#${this.IdChart}`).height();
        if (width > 0 && height > 0) {
          this.renderer.setStyle(this.graph.nativeElement, 'width', `${width}px`);
          this.renderer.setStyle(this.graph.nativeElement, 'height', `${height}px`);
          this.myChart.resize();
          clearInterval(interval);
        }
      }, 100);
    }

  }
}
